<template>
  <div class="footer">
    <div class="footer-section">
      <div class="footer-addr">
        04617 서울시 중구 동호로 24길 27-17, 우리함께빌딩 3층 / Tel.
        010-1234-5678(02-725-1994)
      </div>
      <!-- <div class="footer-sponsor">
        후원계좌 : KEB하나은행 162-910019-54204 / lcymovie
      </div> -->
      <div class="footer-copyright">
        Copyleft © YIPDMOVIE. Free sharing of copyright.
      </div>
      <div class="footer-sns">
        <a href="http://lcymovie.shop/" target="_blank">
          <i class="fab fa-youtube youtube-icon"></i>
        </a>
        <a href="http://lcymovie.shop/" target="_blank">
          <i class="fab fa-instagram instagram-icon"></i>
        </a>
        <a href="http://lcymovie.shop/" target="_blank">
          <i class="fab fa-x-twitter x-twitter-icon"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<style>
@import "../assets/css/footer.css";
</style>
